module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av527-10b10adeb35d27691ecdff3c0ef35f72.jpg";